import { useGetChildrenQuizzes } from '@repo/api/parent/useGetChildrenQuizzes';
import { useGetMyChildren } from '@repo/api/parent/useGetMyChildren';

import { ChildSectionList } from '@/components/features/parent/ChildSectionList';
import ParentPageHeader from '@/components/features/parent/layout/ParentPageHeader';
import { ParentListSection } from '@/components/features/parent/ParentListSection';
import { ParentListToolbar } from '@/components/features/parent/ParentListToolbar';
import { ParentQuizAttemptCard } from '@/components/features/parent/ParentQuizAttemptCard';
import { ParentQuizAttemptDialog } from '@/components/features/parent/ParentQuizAttemptDialog';
import { useParentListParams } from '@/hooks/parent';

export default function ParentQuizzesPage() {
  const { data: children = [], isPending: isPendingChildren, isError, errorMessage } = useGetMyChildren();
  const listParams = useParentListParams();

  const { results, failed, isPending } = useGetChildrenQuizzes(children, listParams.buildParamsFor, !isPendingChildren);

  return (
    <div className={'base-direction-col'}>
      <div className={'flex w-full grow flex-col gap-6'}>
        <ParentPageHeader title={'Quizy'}>
          <ParentListToolbar childUsers={children} listParams={listParams} />
        </ParentPageHeader>

        <ChildSectionList
          results={results}
          failed={failed}
          isPending={isPendingChildren || isPending}
          isError={isError}
          errorMessage={errorMessage}
          summary={(data) => `Wyników: ${data.total}`}
          defaultExpanded={'none'}
        >
          {(data, child) => (
            <ParentListSection childId={child.id} data={data} listParams={listParams} emptyMessage={'Brak rozwiązanych quizów'}>
              {(attempts) => (
                <ul className={'flex flex-col gap-2'}>
                  {attempts.map((attempt) => (
                    <ParentQuizAttemptCard key={attempt.id} attempt={attempt} childId={child.id} />
                  ))}
                </ul>
              )}
            </ParentListSection>
          )}
        </ChildSectionList>
      </div>

      <ParentQuizAttemptDialog />
    </div>
  );
}
